const common = {
  "site.name": "Kakobuy Polska",
  "site.tagline": "Znajdź najlepsze produkty szybciej",
  "site.description": "Kompletny przewodnik Kakobuy Spreadsheet dla użytkowników z Polski. Odkrywaj popularne produkty, sprawdzaj rekomendacje i korzystaj z aktualnych list produktów Kakobuy.",

  "nav.home": "Strona główna",
  "nav.spreadsheet": "Artykuły SEO",
  "nav.categories": "Kategorie",
  "nav.guides": "Poradniki",
  "nav.safety": "Bezpieczeństwo",
  "nav.faq": "FAQ",
  "nav.categoriesList": "Kategorie produktów",

  "hero.title": "Kakobuy Spreadsheet Polska",
  "hero.subtitle": "Znajdź najlepsze produkty szybciej",
  "hero.description": "Kompletny przewodnik Kakobuy Spreadsheet dla użytkowników z Polski. Odkrywaj popularne produkty, sprawdzaj rekomendacje i korzystaj z aktualnych list produktów Kakobuy.",
  "hero.cta.primary": "Sprawdź Kakobuy Spreadsheet",
  "hero.cta.secondary": "Kup teraz",
  "hero.trust.1": "Aktualne listy produktów",
  "hero.trust.2": "Poradniki dla początkujących",
  "hero.trust.3": "Bezpieczne zakupy",
  "hero.trust.4": "Polska wersja językowa",

  "why.title": "Dlaczego Kakobuy Spreadsheet?",
  "why.subtitle": "Odkryj zalety korzystania z naszego przewodnika zakupowego Kakobuy Spreadsheet",
  "why.card1.title": "Szybsze wyszukiwanie",
  "why.card1.desc": "Znajdź interesujące Cię produkty w kilka sekund dzięki uporządkowanym kategoriom i sprawdzonym linkom.",
  "why.card2.title": "Zweryfikowane produkty",
  "why.card2.desc": "Wszystkie produkty w naszym Kakobuy Spreadsheet zostały sprawdzone pod kątem jakości i wiarygodności sprzedawców.",
  "why.card3.title": "Porównanie ofert",
  "why.card3.desc": "Porównuj ceny, opinie i dostępność produktów z różnych kategorii w jednym miejscu.",
  "why.card4.title": "Łatwiejsze zakupy",
  "why.card4.desc": "Kliknij i przejdź bezpośrednio do produktu na Kakobuy – bez zbędnego szukania i marnowania czasu.",

  "categories.title": "Przeglądaj kategorie produktów",
  "categories.subtitle": "Wybierz kategorię i odkryj najlepsze produkty w naszym Kakobuy Spreadsheet. Każda kategoria zawiera zdjęcia produktów i sprawdzone linki.",
  "categories.dropdown.placeholder": "Wybierz kategorię...",

  "how.title": "Jak to działa?",
  "how.subtitle": "Trzy proste kroki, aby znaleźć idealne produkty",
  "how.step1.title": "Znajdź produkt",
  "how.step1.desc": "Przeglądaj kategorie lub skorzystaj z wyszukiwarki, aby znaleźć interesujące Cię produkty w Kakobuy Spreadsheet.",
  "how.step2.title": "Sprawdź informacje",
  "how.step2.desc": "Zapoznaj się ze szczegółami, ocenami i rekomendacjami przed podjęciem decyzji zakupowej.",
  "how.step3.title": "Przejdź do Kakobuy",
  "how.step3.desc": "Kliknij w link i przejdź bezpośrednio do produktu na platformie Kakobuy, aby dokonać zakupu.",

  "articles.title": "Poradniki i artykuły SEO",
  "articles.subtitle": "Poznaj nasze szczegółowe poradniki o Kakobuy Spreadsheet. Od butów po bezpieczeństwo – wszystko, co musisz wiedzieć o zakupach przez chińskich agentów.",
  "articles.viewall": "Zobacz wszystkie poradniki",

  "article.title": "Poradnik Kakobuy Spreadsheet",
  "article.subtitle": "Dowiedz się wszystkiego o Kakobuy Spreadsheet – od podstaw po zaawansowane strategie wyszukiwania produktów",
  "article.preview": "Kakobuy Spreadsheet to niezbędne narzędzie dla każdego, kto chce efektywnie robić zakupy przez chińskich agentów zakupowych. W tym poradniku dowiesz się, jak korzystać z arkuszy Kakobuy, jak znaleźć najlepsze produkty w kategoriach takich jak buty, bluzy, koszulki i akcesoria, oraz jak uniknąć typowych błędów początkujących. Niezależnie od tego, czy szukasz sneakersów, streetwearu czy akcesoriów – nasz Kakobuy Spreadsheet pomoże Ci zaoszczędzić czas i pieniądze...",
  "article.readmore": "Czytaj cały artykuł",

  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Odpowiedzi na najczęstsze pytania dotyczące Kakobuy Spreadsheet",
  "faq.q1": "Czym jest Kakobuy Spreadsheet?",
  "faq.a1": "Kakobuy Spreadsheet to uporządkowana lista produktów dostępnych na platformie Kakobuy, zawierająca linki, ceny, oceny i kategorie. Ułatwia szybkie znalezienie sprawdzonych produktów bez konieczności ręcznego przeszukiwania całej platformy.",
  "faq.q2": "Czy Kakobuy Spreadsheet jest darmowy?",
  "faq.a2": "Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy go społeczności, aby ułatwić zakupy i pomóc w znalezieniu najlepszych produktów w atrakcyjnych cenach.",
  "faq.q3": "Jak często aktualizowany jest Kakobuy Spreadsheet?",
  "faq.a3": "Regularnie aktualizujemy nasz Kakobuy Spreadsheet, aby zapewnić aktualność linków, cen i dostępności produktów. Nowe produkty są dodawane, a nieaktualne usuwane na bieżąco.",
  "faq.q4": "Czy zakupy przez Kakobuy są bezpieczne?",
  "faq.a4": "Kakobuy to renomowana platforma agenta zakupowego z Chin. Korzystając z naszego Kakobuy Spreadsheet, otrzymujesz linki do zweryfikowanych sprzedawców i sprawdzonych produktów, co zwiększa bezpieczeństwo Twoich zakupów.",
  "faq.q5": "Jak mogę uzyskać dostęp do Kakobuy Spreadsheet?",
  "faq.a5": "Wystarczy kliknąć przycisk \"Sprawdź Kakobuy Spreadsheet\" na górze strony lub wybrać interesującą Cię kategorię z listy. Zostaniesz przekierowany bezpośrednio do odpowiedniej sekcji na naszej głównej stronie.",

  "cta.title": "Gotowy, aby znaleźć najlepsze produkty?",
  "cta.subtitle": "Dołącz do tysięcy zadowolonych użytkowników Kakobuy Spreadsheet i odkryj świat świetnych okazji.",
  "cta.button": "Sprawdź Kakobuy Spreadsheet już teraz",

  "footer.copyright": "© 2026 Kakobuy Polska. Wszelkie prawa zastrzeżone.",
  "footer.disclaimer": "Ta strona jest niezależnym przewodnikiem i nie jest powiązana z Kakobuy. Wszystkie linki prowadzą do zewnętrznych stron.",
  "footer.home": "Strona główna",
  "footer.article": "Poradnik Spreadsheet",
  "footer.articleButy": "Poradnik Buty",
  "footer.articleBezpieczenstwo": "Bezpieczeństwo",
  "footer.articleWysylka": "Wysyłka",
  "footer.articlePoczatkujacy": "Początkujący",
  "footer.categories": "Kategorie",

  "article.page.title": "Kakobuy Spreadsheet – Kompletny Poradnik dla Kupujących z Polski",
  "article.page.back": "← Powrót do strony głównej",

  "breadcrumb.home": "Strona główna",
  "breadcrumb.article": "Poradnik Kakobuy Spreadsheet"
};

export default common;